// extracted by mini-css-extract-plugin
module.exports = {"desktop":"min-width: 75em","container":"TryAudioSearch_container__KYSog","buttonsWrapper":"TryAudioSearch_buttonsWrapper__x8Ib_"};